<template>
  <div id="page_pool" class="column p0 minH100">
    <div class="cointainer_lg column combo_1" v-if="pageLoad">
      <div class="page_landing_welcome_title">
        <h1 class="component_title_lg fat m0_b">Blue Pool</h1>
      </div>

      <div
        class="backgorund_modal"
        style="overflow-x: unset !important"
        v-if="modalLast"
      >
        <modal-last-pool
          @toggleModalCurrencies="toogleModal()"
          :membersOnPoolProgram="lastMonthPools"
          :month="monthToRender"
        ></modal-last-pool>
      </div>

      <div class="cointainer_lg combo_1 container_pool">
        <div class="column rewards_container" v-if="member.poolProgram && pool">
          <div class="rewards_box">
            <h3>
              {{
                $t("msg.monthly_rewards", {
                  month: $t(`msg.months.${this.poolMonth}`),
                })
              }}:
            </h3>

            <div class="content_rewards" v-if="pool.amount">
              <img
                class="blue_token_rewards"
                src="../../assets/images/blue_icon.svg"
                alt="blue_token"
              />
              <div class="data_rewards">
                <p>{{ pool.amount }}</p>
                <div v-if="pool.amount * bluValue[0].value > 0">
                  <span
                    >≈
                    {{ parseInt(pool.amount * bluValue[0].value) }} USDT</span
                  >
                </div>
              </div>
            </div>
            <div v-else style="height: 100%">
              <loading></loading>
            </div>
          </div>

          <div class="arrow_reward">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="arrow"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <div class="rewards_box">
            <h3>{{ $tc("msg.my_rewards", 1) }}:</h3>

            <div v-if="memberPoolInfo" class="content_rewards">
              <img
                class="blue_token_rewards"
                src="../../assets/images/blue_icon.svg"
                alt="blue_token"
              />
              <div class="data_rewards">
                <div v-if="memberPoolInfo.referralVolume >= 1">
                  <p>{{ memberPoolInfo.estimated.toFixed(2) }}</p>
                  <span
                    >≈
                    {{
                      (memberPoolInfo.estimated * bluValue[0].value).toFixed(2)
                    }}
                    USDT</span
                  >
                </div>

                <div v-else>
                  <p>0.00</p>
                </div>
              </div>
            </div>
            <div v-else style="height: 100%">
              <loading></loading>
            </div>
          </div>
        </div>

        <div class="column rewards_container" v-else>
          <div class="rewards_box">
            <h3 :style="pool ? '' : 'color:transparent'">
              {{
                $t("msg.monthly_rewards", {
                  month: $t(`msg.months.${this.poolMonth}`),
                })
              }}:
            </h3>

            <div class="content_rewards">
              <img
                class="blue_token_rewards"
                src="../../assets/images/blue_icon.svg"
                alt="blue_token"
              />
              <div v-if="pool" class="data_rewards">
                <div v-if="pool && bluValue[0]">
                  <p>{{ pool.amount }}</p>
                  <div>
                    <span
                      >≈
                      {{ parseInt(pool.amount * bluValue[0].value) }} USDT</span
                    >
                  </div>
                </div>

                <div v-else style="height: 20%">
                  <loading></loading>
                </div>
              </div>

              <div v-else class="calculating">
                <span>{{ $tc("msg.calculating", 1) }}</span>
              </div>
            </div>
          </div>

          <div class="arrow_reward">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="arrow"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <div class="rewards_box">
            <h3>{{ $tc("msg.my_rewards", 1) }}:</h3>

            <div class="content_rewards" style="justify-content: space-between">
              <img
                class="blue_token_rewards"
                src="../../assets/images/blue_icon.svg"
                alt="blue_token"
              />
              <div class="data_rewards"></div>
            </div>
          </div>
        </div>

        <div v-if="modal">
          <modalPool
            v-bind:joinPool="joinPool"
            @closeModalPool="showModal()"
            @reloadUser="reloadUsers()"
          />
        </div>

        <div style="width: 100%; text-align: right">
          <span
            v-if="lastMonthPools.length > 0"
            @click="toogleModal()"
            style="
              color: orange;
              text-decoration: underline;
              cursor: pointer;
              margin-right: 20px;
            "
            >{{ $tc("msg.last_month_winners", 1) }}
          </span>
        </div>

        <div
          class="column qualification_status"
          v-if="member.poolProgram && pool && referralVolume < 1"
        >
          <div style="display: flex; justify-content: space-between">
            <h2>{{ $tc("msg.qualification_status", 1) }}</h2>
          </div>
          <div class="wrapper_bar">
            <div class="bar">
              <p
                :style="{
                  marginLeft: [(referralVolume * 100).toFixed(2) + '%'],
                }"
              >
                {{ referralVolume.toFixed(2) }} BLUE
              </p>

              <span
                class="left_to_qualification"
                :style="{
                  marginLeft: [(referralVolume * 100).toFixed(2) + '%'],
                }"
              >
                {{ $tc("msg.need_to_qualify", 1) }}
                {{ (1 - referralVolume).toFixed(2) }} BLUE
                {{ $tc("msg.to_qualify", 1) }}
              </span>

              <div class="coin_bar m13_t">
                <span
                  class="coin_bar_filled"
                  :style="{
                    width: [(referralVolume * 100).toFixed(2) + '%'],
                  }"
                ></span>
              </div>
            </div>

            <div class="blue_image">
              <img src="../../assets/images/blue_icon.svg" alt="blue_token" />
              <p>1 BLUE</p>
            </div>
          </div>
        </div>

        <div
          class="column wrapper_join_pool"
          v-if="
            pool && (membersOnPoolProgram.length > 0 || !member.poolProgram)
          "
        >
          <div class="wrapper_winners">
            <a v-html="$t('msg.how_it_works')"></a>
          </div>

          <div class="title_and_btn">
            <h3 v-if="membersOnPoolProgram.length > 0">
              {{ $tc("msg.leaderboard", 1) }}
            </h3>
          </div>

          <div class="title_and_btn">
            <button v-if="!member.poolProgram" @click="showModal()">
              {{ $tc("msg.join_pool", 1) }}
            </button>

            <div class="wrapper_winners" style="color: transparent" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="table_pool" v-if="pool">
          <div v-if="membersOnPoolProgram.length > 0">
            <div class="table_container">
              <table>
                <thead>
                  <tr>
                    <th style="text-align: left">Avatar</th>
                    <th style="text-align: right">
                      {{ $tc("msg.referral_volume", 1) }}
                    </th>
                    <th style="text-align: right">
                      {{ $tc("msg.reward_pool", 1) }}
                    </th>
                    <th style="text-align: right">
                      {{ $tc("msg.estimated_pool", 1) }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, index) in membersOnPoolProgram"
                    :key="index"
                    :style="
                      memberPoolInfo.nickname == item.nickname
                        ? 'background: #b5c2f0; font-weight: 600'
                        : ''
                    "
                  >
                    <td>
                      <div class="icon_table">
                        <img
                          :src="renderImage(item.avatar)"
                          :alt="item.avatar"
                        />
                        <span>{{ item.nickname }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="icon_table_numbers">
                        <img
                          src="../../assets/images/blue_icon.svg"
                          alt="blue_token"
                          style="width: 1.2rem !important"
                        />
                        <span>{{
                          item.referralVolume && item.referralVolume.toFixed(2)
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="icon_table_numbers">
                        <div></div>
                        <span
                          >{{
                            item.rewardPercent && item.rewardPercent.toFixed(2)
                          }}%</span
                        >
                      </div>
                    </td>
                    <td>
                      <div class="icon_table_numbers">
                        <img
                          src="../../assets/images/blue_icon.svg"
                          alt="blue_token"
                          style="width: 1.2rem !important"
                        />
                        {{ item.estimated && item.estimated.toFixed(2) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button v-if="membersOnPoolProgram.length > 10">
                {{ $tc("msg.view_all", 1) }}
              </button>
            </div>
          </div>

          <div v-if="loadingTable" style="height: 20%">
            <loading></loading>
          </div>

          <div
            v-else-if="!loadingTable && membersOnPoolProgram.length == 0"
            class="nobody_has_qualified"
          >
            <p>
              {{ $tc("msg.nobody_qualified", 1) }}
            </p>
          </div>
        </div>

        <div v-else class="check_again_soon">
          <p>{{ $tc("msg.posted_soon", 1) }}</p>
        </div>
      </div>
    </div>

    <div class="cointainer_lg column combo_1" v-else>
      <div class="page_landing_welcome_title">
        <h1 class="component_title_lg fat m0_b">Blue Pool</h1>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin-top: 2rem;
        "
      >
        <loading
          style="
            background: #e2e2e2;
            width: 200px;
            padding: 10px;
            padding-bottom: 20px;
            border-radius: 20px;
          "
        ></loading>
        <p>{{ $tc("msg.loading", 1) }}</p>
      </div>
    </div>
  </div>
</template>
 
<script>
import { mapGetters } from "vuex";
import avatar1 from "../../assets/images/Avatar-Blue-Pool/avatar1.svg";
import avatar2 from "../../assets/images/Avatar-Blue-Pool/avatar2.svg";
import avatar3 from "../../assets/images/Avatar-Blue-Pool/avatar3.svg";
import avatar4 from "../../assets/images/Avatar-Blue-Pool/avatar4.svg";
import avatar5 from "../../assets/images/Avatar-Blue-Pool/avatar5.svg";
import avatar6 from "../../assets/images/Avatar-Blue-Pool/avatar6.svg";
import avatar7 from "../../assets/images/Avatar-Blue-Pool/avatar7.svg";
import avatar8 from "../../assets/images/Avatar-Blue-Pool/avatar8.svg";
import avatar9 from "../../assets/images/Avatar-Blue-Pool/avatar9.svg";
import avatar10 from "../../assets/images/Avatar-Blue-Pool/avatar10.svg";
import modalPool from "../../components/modals/modalPool";
import loading from "../../components/public/LoadingCoinsSlider.vue";
import moment from "moment";

import modalLastPool from "../../components/modals/modalLastPool.vue";

export default {
  created() {
    this.getMember();
    this.getActivePool();
    this.getPoolSummary();
    this.getPoolInfoOfMember();

    this.getCunrrencies();

    this.getSummaryByDate();
  },
  mounted() {},

  data: () => ({
    member: [],
    modalLast: false,
    table: [
      {
        avatar: "avatar1",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar1,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar2",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar2,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar3",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar3,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar4",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar4,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar5",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar5,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar6",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar6,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar7",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar7,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar8",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar8,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar9",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar9,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar10",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar10,
        blue: "../../assets/images/blue_icon.svg",
      },
      {
        avatar: "avatar10",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: avatar1,
        blue: "../../assets/images/blue_icon.svg",
      },
    ],
    loadingTable: true,
    membersOnPoolProgram: [],
    pool: [],
    poolMonth: "",
    modal: false,
    memberPoolInfo: [],
    referralVolume: 0,
    lastMonthPools: [],
    pageLoad: false,
    monthToRender: ""
  }),

  components: {
    modalPool,
    loading,
    modalLastPool,
  },

  methods: {
    async getActivePool() {
      let resp = await this.$store.dispatch("getActivePool");
      this.pool = resp.data.filter((item) => item.active)[0];

      if (this.pool) {
        this.poolMonth = moment(this.pool.startAt).format("M");
      }
    },

    toogleModal() {
      this.modalLast = !this.modalLast;
    },

    async getCunrrencies() {
      let resp = await this.$store.dispatch("updateCurrencies");
      console.log(resp, "resp aq");
    },

    async getPoolInfoOfMember() {
      let resp = await this.$store.dispatch("getPoolUser");

      if (resp.status == 200) {
        this.memberPoolInfo = resp.data;
        resp.data.referralVolume &&
          (this.referralVolume = resp.data.referralVolume);
      } else {
        console.log(resp);
      }
    },

    async getSummaryByDate() {
      let date = new Date();
      let month = date.getMonth();
      let year = date.getFullYear();
      this.monthToRender = date.getMonth();

      if (month < 10) {
        month = "0" + month;
      }

      var teste = new Date(),
      y = teste.getFullYear(),
      m = date.getMonth();
      var lastDay = new Date(year, month, 0);

      let last = lastDay.getDate();
      this.month = month;

      let start = `${year}-${month}-01T00:28:21.0Z`;
      let end = `${year}-${month}-${last}T23:28:21.0Z`;

      let params = {
        startAt: start,
        endAt: end,
      };

      let resp = await this.$store.dispatch("getPoolsSummaryByDate", params);
      if (resp.status == 200) {
        let allPools = resp.data;
        for (let i in allPools) {
          if (allPools[i].referralVolume >= 1) {
            this.lastMonthPools.push(allPools[i]);

            this.lastMonthPools.sort(function (a, b) {
              if (a.referralVolume < b.referralVolume) {
                return 1;
              }
              if (a.referralVolume > b.referralVolume) {
                return -1;
              }
              return 0;
            });
          }
          this.loadingTable = false;
        }
      } else {
        alert("Something wrong");
      }

      this.pageLoadingFinish();
    },

    pageLoadingFinish() {
      this.pageLoad = true;
    },

    async getPoolSummary() {
      await this.$store
        .dispatch("getPoolsSumarry")
        .then(async (response) => {
          if (response.status == 200) {
            this.membersOnPoolProgram = response.data.filter(
              (member) => member.referralVolume >= 1
            );

            this.membersOnPoolProgram.sort(function (a, b) {
              if (a.referralVolume < b.referralVolume) {
                return 1;
              }
              if (a.referralVolume > b.referralVolume) {
                return -1;
              }
              return 0;
            });

            this.loadingTable = false;
          } else {
            console.log(response);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getMember() {
      await this.$store.dispatch("getMember").then((resp) => {
        this.member = resp;
      });
    },

    showModal() {
      this.modal = !this.modal;
    },

    async getPoolUser() {
      await this.$store.dispatch("getPoolUser").then((resp) => {
        this.poolUser = resp.data;
      });
    },

    reloadUsers() {
      // this.getMember();
      // this.getPoolSummary();
      // this.getPoolInfoOfMember();

      this.getMember();
      this.getActivePool();
      this.getPoolSummary();
      this.getPoolInfoOfMember();
    },

    renderImage(e) {
      if (e == "avatar1") {
        return avatar1;
      } else if (e == "avatar2") {
        return avatar2;
      } else if (e == "avatar3") {
        return avatar3;
      } else if (e == "avatar4") {
        return avatar4;
      } else if (e == "avatar5") {
        return avatar5;
      } else if (e == "avatar6") {
        return avatar6;
      } else if (e == "avatar7") {
        return avatar7;
      } else if (e == "avatar8") {
        return avatar8;
      } else if (e == "avatar9") {
        return avatar9;
      } else if (e == "avatar10") {
        return avatar10;
      }
    },
  },

  computed: {
    ...mapGetters(["bluValue", "joinPool"]),
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/views/private/Pool.vue